
import LoadingComponent from "./loading.vue";
import Vue from 'vue';

const Loading = {
    install(Vue, options) {
        this.EventBus = new Vue();

        Vue.component("app-loading", LoadingComponent);
        Vue.prototype.$loading = {
            show() {
                Loading.EventBus.$emit("show");
            },
            hide() {
                Loading.EventBus.$emit("hide");
            }
        };
    }
};

Vue.use(Loading);

export default Loading;